import { resolveMediaUrl } from '../salon-admin/utils/mediaUrl';
import { FRANCHISE_FLOW_STORAGE_KEY } from './franchiseFlowAuth';

export const FRANCHISE_BRAND_LOGO_KEY = 'enterprise_franchise_brand_logo';
export const FRANCHISE_BRAND_NAME_KEY = 'enterprise_franchise_brand_name';
/** Keep in sync with guestFlowAuth.GUEST_FLOW_STORAGE_KEY (avoid circular import). */
const GUEST_FLOW_STORAGE_KEY = 'enterprise_guest_flow_auth';

export function resolveFranchiseLogoUrl(raw) {
  return resolveMediaUrl(raw) || (typeof raw === 'string' ? raw.trim() : '') || '';
}

function readBrandFromStorageKey(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return { logo: '', name: '' };
    const auth = JSON.parse(raw);
    const logo = resolveFranchiseLogoUrl(auth?.franchise_logo || auth?.org_logo);
    const name = String(auth?.franchise_name || auth?.org_name || auth?.organization_name || '').trim();
    return { logo, name };
  } catch {
    return { logo: '', name: '' };
  }
}

export function readFranchiseBrandFromSession() {
  const fromFranchise = readBrandFromStorageKey(FRANCHISE_FLOW_STORAGE_KEY);
  if (fromFranchise.logo || fromFranchise.name) return fromFranchise;
  return readBrandFromStorageKey(GUEST_FLOW_STORAGE_KEY);
}

export function readStoredFranchiseBrandLogo() {
  const fromAuth = readFranchiseBrandFromSession();
  if (fromAuth.logo) return fromAuth.logo;
  try {
    return resolveFranchiseLogoUrl(localStorage.getItem(FRANCHISE_BRAND_LOGO_KEY));
  } catch {
    return '';
  }
}

export function readStoredFranchiseBrandName() {
  const fromAuth = readFranchiseBrandFromSession();
  if (fromAuth.name) return fromAuth.name;
  try {
    return String(localStorage.getItem(FRANCHISE_BRAND_NAME_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function persistFranchiseBrand({ logo, name } = {}) {
  try {
    if (logo) {
      const resolved = resolveFranchiseLogoUrl(logo) || String(logo).trim();
      if (resolved) localStorage.setItem(FRANCHISE_BRAND_LOGO_KEY, resolved);
    }
    if (name) {
      const trimmed = String(name).trim();
      if (trimmed) localStorage.setItem(FRANCHISE_BRAND_NAME_KEY, trimmed);
    }
  } catch {
    /* ignore */
  }
}

export function clearFranchiseBrandStorage() {
  try {
    localStorage.removeItem(FRANCHISE_BRAND_LOGO_KEY);
    localStorage.removeItem(FRANCHISE_BRAND_NAME_KEY);
    localStorage.removeItem('enterprise_salon_org_logo');
    localStorage.removeItem('enterprise_salon_org_name');
  } catch {
    /* ignore */
  }
}
